import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import PanelGroupController from "../components/PanelGroupController";
import PanelHeaderItem from "../components/PanelHeaderItem";
import FilterPanel from "../components/panels/FilterPanel";
import SkuFilterPanel from "./panels/SkuFilterPanel";
import ProductWaitingList from "./views/ProductWaitingList";
import CustomerPropertiesPanel from "../customers/panels/CustomerPropertiesPanel";
import {withApollo} from "react-apollo";
import {List, fromJS} from "immutable";

const shopFilterOptions = fromJS([
  {id: "", label: "All Shops"},
  {id: "alpine-water-gmbh", label: "Alpine Water GmbH"},
  {id: "alpine-water-usa-llc", label: "Alpine Water USA LLC"}
])

const kindFilterOptions = fromJS([
  {id: "", label: "Any"},
  {id: "product", label: "Product"},
  {id: "subscription", label: "Subscription"}
])

class ProductWaitingListPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handlePanelItemSelection = this.handlePanelItemSelection.bind(this);
    this.state = {
      selectedId: "",
      customerId: "",
      hasSelection: false,
      selectedPanelId: "general",
      shopFilter: "",
      kindFilter: "",
      skuFilter: ""
    }
  }

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Product Waiting List";

    return (
      <div className="SalesPage ProductWaitingListPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem show={true} label="Filter" id="general" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={this.state.hasSelection} label="Customer" id="customer" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
          </div>
          {panels}
          <PanelGroupController title="Actions">
          </PanelGroupController>
        </div>
      </div>
    );
  }

  renderView(page) {
    switch(page) {
      case "list":
        return (
          <ProductWaitingList 
            selectedId={this.state.selectedId} 
            onSelectionChange={this.handleSetSelection}
            shopFilter={this.state.shopFilter}
            kindFilter={this.state.kindFilter}
            skuFilter={this.state.skuFilter}
            />
        )
      default: 
        return <p>No view found</p>
    }
  }

  renderPanels(page) {
    switch(page) {
      case "list":
        if (this.state.selectedPanelId === "customer") {
          return this.buildPanels(List(["customerProperties"]));
        } else {
          return this.buildPanels(List(["shopFilter", "kindFilter", "skuFilter"]));
        }
      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case "shopFilter":
        return <FilterPanel
          key="ShopFilterPanel"
          title="Shop Filter"
          expanded={true}
          options={shopFilterOptions}
          onClick={this.handleSetShopFilter.bind(this)}
          filter={this.state.shopFilter}
          />      

      case "kindFilter":
        return <FilterPanel
          key="KindFilterPanel"
          title="Kind Filter"
          expanded={true}
          options={kindFilterOptions}
          onClick={this.handleSetKindFilter.bind(this)}
          filter={this.state.kindFilter}
          />        

      case "skuFilter":
        return <SkuFilterPanel
          key="SkuFilterPanel"
          title="Product Filter"
          onClick={this.handleSetSkuFilter.bind(this)}
          filter={this.state.skuFilter}
          />        

      case "customerProperties":
        return <CustomerPropertiesPanel
          key="CustomerPropertiesPanel"
          expanded={true}
          customerId={this.state.customerId}
          hasSelection={this.state.hasSelection}
          />

      default:
        return null;      
    }
  } 

  handleSetShopFilter(item) {
    this.setState({
      shopFilter: item.get("id")
    });
  }     

  handleSetKindFilter(item) {
    this.setState({
      kindFilter: item.get("id")
    });
  }     

  handleSetSkuFilter(sku) {
    this.setState({
      skuFilter: sku
    });
  }     

  handlePanelItemSelection(id) {
    this.setState({selectedPanelId: id});
  }  

  handleSetSelection(item) {
    this.setState({
      selectedId: item.get("id"),
      customerId: item.get("customerId"), 
      hasSelection: true, 
      selectedPanelId: "customer"
    });
  }

}

export default withApollo(ProductWaitingListPage);